import state from './state'
import mutations from './mutations'
import actions from './actions'

const ReportStore = {
  namespaced: true,
  state,
  mutations,
  actions,
}

export default ReportStore
